import { action } from 'mobx';

import { AppManager, Input } from 'core/index';
import { SetToken } from 'core/jwt';

import { ProfileModel } from 'apps/profile/app';
import { UserApp } from 'apps/user/app';
import { TagsApp } from 'apps/tag/app';
import { clientStore } from 'apps/client/app';
import { SignUpMutation } from 'apps/profile/gql';

import { i18n } from 'config/i18n';

import { SignUpApp } from './app';

export class SignUpAppManager extends AppManager {
  static registryName = 'SignUpAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.signUpApp = new SignUpApp(this, {
      user: new UserApp(),
      skills: new TagsApp(),
    });
    this.signUpApp.init(init.isModal);
    this.signUpInput = new Input({
      username: () => this.signUpApp.user.username.trim(),
      email: () => this.signUpApp.user.email.trim(),
      password: () => this.signUpApp.user.password,
      // emailsEnabled: () => this.signUpApp.user.emailsEnabled,
      emailsEnabled: () => true,
      fullName: () => this.signUpApp.fullName,
      preferredName: () => this.signUpApp.preferredName,
      bio: () => this.signUpApp.bio,
      intentId: () => this.signUpApp.intent,
      userTypeId: () => this.signUpApp.userType,
      skills: () =>
        this.signUpApp.skills.map(({ id, name, deleted }) => ({
          id,
          name,
          deleted,
        })),
      locale: () => i18n.language,
      startFreeTrial: () => !!init.params.get('trial'),
      encodedExtra: () => init.params.get('p'),
    });
    const headers = {};
    if (clientStore.HMAC) headers['X-Wikifactory-Hmac'] = clientStore.HMAC;
    this.signUpMutation = new SignUpMutation(
      this.signUpInput,
      null,
      {},
      false,
      headers,
    );
    this.signUpMutation.process(
      profile => ProfileModel.Load(profile),
      this.SetProfile,
      { subPath: 'profile' },
    );
    this.signUpMutation.process(
      token => {
        if (token) SetToken(token);
      },
      () => {},
      { subPath: 'token' },
    );
  }

  @action SignUp = options => {
    this.signUpMutation.setCallbacks(options);
    this.signUpMutation.mutate();
  };

  @action SetProfile = profileModel => {
    clientStore.SetSignedInProfile(profileModel);
  };
}
